// File: assets/pdfExport.js
(function() {
  // Внедряем стили для кнопки и скрытие при печати
  const style = document.createElement('style');
  style.textContent = `
    #print-pdf-btn {
      position: fixed;
      top: 7rem;
      right: 1rem;
      padding: .5rem 1rem;
      background: #00CCFF;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      z-index: 10000;
      font-size: 1rem;
    }
    #print-pdf-btn:hover {
      filter: brightness(1.1);
    }
    @media print {
      #print-pdf-btn {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function() {
    // Создаём кнопку «Print…»
    const btn = document.createElement('button');
    btn.id          = 'print-pdf-btn';
    btn.textContent = 'Print…';
    document.body.appendChild(btn);

    btn.addEventListener('click', function() {
      // Раскрыть все секции перед печатью
      document.querySelectorAll('.section').forEach(s => s.classList.add('visible'));
      document.querySelectorAll('.term-detail').forEach(d => {
        d.classList.add('open');
        const summary = d.querySelector('.term-summary');
        const content = d.querySelector('.detail-content');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      });

      // Открыть нативный диалог печати (с возможностью «Сохранить как PDF»)
      window.print();
    });
  });
})();
